import { useEffect, useState } from "react";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";

function ExtraAddresses({ value, onChange }) {
  const [text, setText] = useState(value.join(", "));
  useEffect(() => {
    const typed = text.split(",").map((s) => s.trim()).filter(Boolean);
    if (typed.join(",") !== value.join(",")) setText(value.join(", "));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Input value={text} placeholder="Other addresses, comma separated" className="mt-2 h-9 max-w-md" data-testid="sow-email-to-extra"
      onChange={(e) => { setText(e.target.value); onChange(e.target.value.split(",").map((s) => s.trim()).filter(Boolean)); }} />
  );
}

export function RecipientsEditor({ kind, roles, value, onChange, alertList }) {
  const toggle = (r) => onChange({ ...value, to_roles: value.to_roles.includes(r) ? value.to_roles.filter((x) => x !== r) : [...value.to_roles, r] });
  return (
    <div className="rounded-lg border border-stone-200 bg-stone-50/60 p-4 grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="sow-email-recipients">
      <div>
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500 mb-2">To</p>
        <div className="flex flex-col gap-1">
          {kind.roles.map((r) => (
            <label key={r} className="flex items-center gap-2 text-sm text-stone-700 cursor-pointer" title={roles[r]?.hint}>
              <Checkbox checked={value.to_roles.includes(r)} onCheckedChange={() => toggle(r)} data-testid={`sow-email-to-role-${r}`} />
              <span>{roles[r]?.label || r}</span>
            </label>
          ))}
        </div>
        <ExtraAddresses value={value.to_extra} onChange={(v) => onChange({ ...value, to_extra: v })} />
      </div>
      <div className="text-sm text-stone-600" data-testid="sow-email-fixed-rules">
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500 mb-2">Always</p>
        <p>Copied (cc) to the <span className="font-medium text-stone-800">SOW alert list</span>, and replies go to the SOW alert list.</p>
        <p className="mt-1 text-xs text-stone-500">{(alertList || []).join(", ") || "No alert list set yet"} · change it in the Settings panel above.</p>
      </div>
    </div>
  );
}
